import { Token } from "./tokens";

export interface IExchangeOrders {
    id?: string;
    creationDate?: Date;
    closingDate?: Date;
    orderType: ExchangeMarketFlow;
    price: number; // Total amount in fiduciary (with taxes)
    quantity: number; // Amount in tokens
    token: string; // Token id
    status: ExchangeOrderStatus;
    percentageRemaining: number;
    executionsHistory?: Array<IExchangeOrderTransaction>;
    validityType: IValidityType;
    validityDate: Date;
}

export interface IExchangeOrdersCreation {
    orderType: ExchangeMarketFlow;
    tokenPrice: number; // Token price in displayCurrency/base currency
    totalAmount: number; // Total amount in pair currency
    quantity: number; // Amount in tokens
    token: Token; // Token id
    isLimit: boolean;
    isBuy: boolean;
    validityDate?: Date;
    pairTokenId?: string;
    displayCurrency?: string; // Reference currency used for display (e.g. 'BRL', 'USD', 'EUR')
    originalPairAmount?: number; // Total amount converted to displayCurrency for reference
    executionPriceInPair?: number; // Token price converted to pair currency for calculations/execution
}

export interface IExchangeOrderTransaction {
    date: Date;
    quantity: number;
    quotation: number;
    wallet: string;
    price: number
}

export enum ExchangeMarketFlow {
    ALL = 'ALL',
    BUY = 'BUY',
    SELL = 'SELL'
}

export enum ExchangeOrderStatus {
    ALL = 'ALL',
    CREATED = "CREATED",
    CANCELLED = "CANCELLED",
    EXECUTED = "EXECUTED"
}

export enum IValidityType {
    EVERYTHING_OR_NOTHING = 'EVERYTHING_OR_NOTHING',
    TODAY = 'TODAY',
    EXECUTE_OR_CANCEL = 'EXECUTE_OR_CANCEL',
    UNTIL_THE_DATE = 'UNTIL_THE_DATE',
    UNTIL_CANCEL = 'UNTIL_CANCEL',
}
